if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}


document.addEventListener("DOMContentLoaded", function () {
  // Minus button
  document.querySelectorAll(".qty_minus").forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();     
      const input = this.closest("quantity-input").querySelector(".quantity__input");
      let currentValue = parseInt(input.value, 10) || 0;
      let min = parseInt(input.getAttribute("min"), 10) || 0;

      if (currentValue > min) {
        input.value = currentValue - 1;
        input.dispatchEvent(new Event("change")); // optional, in case you need live updates
          const row = this.closest(".variant-item");
      updateVariantTotal(row,false);
      updateCartTotals();
      }
    });
  });

  // Plus button
  document.querySelectorAll(".qty_plus").forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();      
      const input = this.closest("quantity-input").querySelector(".quantity__input");
      let currentValue = parseInt(input.value, 10) || 0;
      input.value = currentValue + 1;
      input.dispatchEvent(new Event("change")); // optional
       const row = this.closest(".variant-item");
      updateVariantTotal(row, true);
      updateCartTotals();
    });
  });

  document.querySelectorAll(".quantity__input").forEach(input => {
  input.addEventListener("input", function () {
    let value = parseInt(this.value, 10) || 0;
    let min = parseInt(this.getAttribute("min"), 10) || 0;

    if (value < min) {
      this.value = min;
      value = min;
    }

    const row = this.closest(".variant-item");

    // detect increase / decrease if needed
    const previous = parseInt(this.dataset.prevValue || value, 10);
    const isIncrease = value > previous;

    this.dataset.prevValue = value;

    updateVariantTotal(row, isIncrease);
    updateCartTotals();
  });
});



  const removeAllBtn = document.querySelectorAll(
    "quick-order-list-remove-all-button button"
  );

  if (removeAllBtn) {
    removeAllBtn.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        // collect all variant inputs
        const inputs = document.querySelectorAll(".quantity__input");
        let updates = {};

        inputs.forEach((input) => {
          const variantId = input.getAttribute("data-quantity-variant-id");
          if (variantId) {
            updates[variantId] = 0; // set quantity to 0 in Shopify
            input.value = 0; // update UI only
          }
        });

        // send update request to Shopify
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        })
          .then((res) => res.json())
          .then((cart) => {
            window.location.reload();
          })
          .catch((err) => console.error("Error clearing cart:", err));
      });
    });
  }

// Update a single row
function updateVariantTotal(row, addToCart) {
  const input = row.querySelector(".quantity__input");
  const priceEl = row.querySelector(".variant-item__price .price");
  const totalEls = row.querySelectorAll(".variant-item__totals .price");
  const variantId = input.getAttribute("data-quantity-variant-id");

  if (!input || !priceEl || totalEls.length === 0) return;

  const quantity = parseInt(input.value, 10) || 0;
  const price = parseFloat(priceEl.textContent.replace(/[^0-9.-]+/g, "")) || 0;

  const total = quantity * price;
  totalEls.forEach(el => {
    el.textContent = `$${total.toFixed(2)}`;
  });
  //updateShopifyCart(variantId, quantity, addToCart); // update Shopify cart
}

  // 🔑 Reusable function to update Shopify cart
function updateShopifyCart(variantId, quantity, addToCart ) {
  if(addToCart==true){
    $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
              quantity:1,
              id:Number(variantId),
            },
            success: function(res){
                get_cart();
            },
            error: function(error){
              console.log(error);
            } });
  }else{
    $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              quantity:quantity,
              id:Number(variantId),
            },
            success: function(res){
                get_cart();
            },
            error: function(error){
              console.log(error);
            } });
  }

}

function get_cart(){        
  jQuery.getJSON('/cart.js', function(cart) {
           var html = '';
           var count = 0;
            for(var i=0; i<cart.items.length; i++){
              
              var item = cart.items[i];
             
              var forloop = i + 1; 
              
              if(item.product_title != 'Gift Box'){
                count += item.quantity; 
               html += '<div class="mmc_items">'+
                        '<div class="mmc_img">'+
                           '<a href="'+item.url+'" class="cart_page_image">'+
                              '<img src="'+item.image+'"/>'+
                            '</a>'+
                        '</div>'+
              '<div class="mmc_detail">'+
                '<div class="mmc_title"><a href="'+ item.url+'">'+item.title+'</a> </div>'+
                 
                '<div class="mmc_price" tabindex="0">'+Shopify.formatMoney(item.line_price)+' </div>'+
                
                 '<div class="mmc_qty" data-line-item-key='+forloop+'>'+
                   '<div aria-label="Cart quantity minus" class="mmc_sign mmc_min"><span class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg></span></div>'+
                    '<input class="quantity-input" data-id="'+item.id+'"  type="text" name="quantity" value="'+item.quantity +'" data-line-id="'+ forloop +'">'+
                   '<div aria-label="Cart quantity plus" class="mmc_sign mmc_plus"><spna class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg></span></div>'+
                 '</div> '; 
                
                var  g_name = 'Gift Note for '+item.title;
                var gift = false , gift_txt = '',  class_active = '', style_show = '', name_att = '';
                    
                $(cart.attributes).each(function(index, attribute){
                   var name = 'Gift Note for '+item.title;
                   var first_title =  attribute[name];
                  
                  if(typeof first_title !== "undefined"){
                        var gift = true;
                        class_active = 'active';
                          style_show = 'style="display:block"';
                        gift_txt = attribute[name];
                        name_att = 'name="attributes['+name+']"';
                  }
                });
                         
            // get market type from body
              const marketType = document.body.dataset.marketType;

              // add giftwrap option only if NOT b2b-market
              if (marketType !== "b2b-market") {
                html +=  
                  '<div class="giftwrap-option" data-va="'+ gift+'"> '+
                    '<button class="giftwrap_btn '+class_active+'" data-qty="'+ item.quantity +'"  data-item-id="'+item.id+'" data-val="Gift Note for '+ item.title +'"   aria-label="Gift Box with Ribbon $6.00">'+
                      '<span class="giftwrap_check"></span>'+
                      '<span class="giftwrap_txt">Gift Box with Ribbon $6.00</span>'+
                    '</button>'+
                  '</div> '+
                  '<div class="gift-note-field" '+style_show+'> '+
                    '<label for="gift-note">Gift Note (Optional)</label> '+
                    '<textarea id="gift-note" '+name_att+' data-val="Gift Note for '+item.title+'" placeholder="Write gift note here.">'+ gift_txt +'</textarea> '+
                  '</div>';
              }

              // always add close button part
              html +=
                '</div>'+
                '<div class="mmc_close">'+
                  '<button data-item-id="'+item.id+'" class="close remove_item" tabindex="0" aria-label="Remove item" data-line="'+ forloop +'">'+
                    '<span class="icon ">'+
                      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">'+
                        '<g id="x">'+
                          '<polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"/>'+
                        '</g>'+
                      '</svg>'+
                    '</span>'+
                  '</button>'+
                '</div>'+
              '</div>';

              }
              
              $('.mmc_item_box').html(html);
             // $('.mmc_total_price').html(Shopify.formatMoney(cart.total_price));
              
              //$('.min_cart').addClass('active');
              $('.header-cart__count').html(count).css('display','flex');
             // $('body').addClass('active_mincart');
               
            }
         });
        
}

document.querySelectorAll(".quantity__input").forEach(input => {
  // Store the initial value
  input.dataset.prevValue = input.value;

  input.addEventListener("change", () => {
    let val = parseInt(input.value, 10);
    const min = parseInt(input.dataset.min, 10) || 0;
    const max = parseInt(input.dataset.max, 10) || 9999;
    const variantId = input.getAttribute("data-quantity-variant-id");

    // ✅ Validation
    if (isNaN(val)) val = min;
    if (val < min) val = min;
    if (val > max) val = max;
    input.value = val;

    const prev = parseInt(input.dataset.prevValue, 10) || 0;
    let direction = null;
    if (val > prev) {
      direction = true;   // quantity increased
    } else if (val < prev) {
      direction = false; // quantity decreased
    }

    updateShopifyCart(variantId, val, direction);

    // Update stored value
    input.dataset.prevValue = val;
  });
});


// Update footer totals
function updateCartTotals() {
  let totalItems = 0;
  let totalPrice = 0;

  document.querySelectorAll(".variant-item").forEach(row => {
    const input = row.querySelector(".quantity__input");
    const priceEl = row.querySelector(".variant-item__price .price");

    if (!input || !priceEl) return;

    const quantity = parseInt(input.value, 10) || 0;
    const price = parseFloat(priceEl.textContent.replace(/[^0-9.-]+/g, "")) || 0;

    totalItems += quantity;
    totalPrice += quantity * price;
  });

  // Update "total items"
  const itemsEl = document.querySelector(".quick-order-list__total-items span");
  if (itemsEl) itemsEl.textContent = totalItems;

  // Update "product total" (your new ID)
  const subtotalEl = document.getElementById("totals__subtotal-value-pdp");
  if (subtotalEl) subtotalEl.textContent = `$${totalPrice.toFixed(2)}`;
}

});

